import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import { Button, Text } from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const InvitationStatusSticker = ({
  isShowInviteStatus,
  title,
  description,
  buttonText,
  handleShowInviteBtnClick,
}) => (
  <>
    { isShowInviteStatus && (
      <div className={cn('status')}>
        <div className={cn('status__title')}>
          <Text size="size3-m">{title}</Text>
        </div>
        <div className={cn('status__description')}>
          <Text size="size5-r-s" color="grey50">{description}</Text>
        </div>
        <div className={cn('status__button')}>
          <Button
            variant="plain"
            onClick={handleShowInviteBtnClick}
          >
            <Text size="size5-r-s" color="grey50">{buttonText}</Text>
          </Button>
        </div>
      </div>
    )}
  </>
);

InvitationStatusSticker.propTypes = {
  isShowInviteStatus: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  handleShowInviteBtnClick: PropTypes.func,
};

export { InvitationStatusSticker };
